import { render, staticRenderFns } from "./layout-compare-button.vue?vue&type=template&id=f09ee134&scoped=true&"
import script from "./layout-compare-button.vue?vue&type=script&lang=js&"
export * from "./layout-compare-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ee134",
  null
  
)

export default component.exports